module.exports = __webpack_public_path__ + "static/images/item-bg.5c97f31.png";